<template>
  <div class="login-main">
    <Header1></Header1>

    <div class="login-box flex-row-center">
      <div class="login">
        <div class="login-left">
          <img src="@/assets/home/login2.png" />
        </div>
        <div class="login-right flex-column-center">
          <div class="login-top">
            <div>用户登录</div>
            <span @click="goTo('/register')">还未注册?</span>
          </div>
          <div class="login-content">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="0"
              class="demo-ruleForm"
            >
              <el-form-item prop="name">
                <el-input
                  placeholder="请输入用户名"
                  v-model="ruleForm.name"
                  prefix-icon="el-icon-user"
                ></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  placeholder="请输入密码"
                  type="password"
                  autocomplete="off"
                  v-model="ruleForm.password"
                  prefix-icon="el-icon-lock"
                ></el-input>
              </el-form-item>
              <el-form-item prop="status">
                <silder-verify
                  @success="handleSuccess"
                  @failed="handleError"
                ></silder-verify>
              </el-form-item>
              <el-form-item style="margin-top: 100px">
                <el-button class="submit-btn" @click="submitForm('ruleForm')"
                  >登陆</el-button
                >
              </el-form-item>
            </el-form>
            <div class="reset-btn-box">
              <el-checkbox v-model="checked">记住登录状态</el-checkbox>
              <span @click="goTo('/resetPw')">忘记密码</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header1 from "@/components/Header1.vue";
import { login, isentlogin } from "@/api/login";
import SilderVerify from "@/components/SilderVerify";
const validatestatus = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请拖动滑块完成验证"));
  } else {
    callback();
  }
};
export default {
  components: {
    SilderVerify,
    Header1,
  },
  data() {
    return {
      type: "user",
      checked: false,
      ruleForm: {
        userName: "",
        password: "",
        status: false,
      },
      rules: {
        name: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { min: 2, max: 10, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入用户密码", trigger: "blur" },
          {
            min: 6,
            max: 18,
            message: "长度在 6 到 18 个字符",
            trigger: "blur",
          },
        ],
        status: [{ validator: validatestatus, trigger: "change" }],
      },
    };
  },
  methods: {
    handleSuccess() {
      this.ruleForm.status = true;
      this.$refs.ruleForm.validateField("status");
    },
    handleError() {},
    goTo(item) {
      this.$router.push(item);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            password: this.ruleForm.password,
            username: this.ruleForm.name,
            webFLag: false
          };
          this.$store.dispatch('login', params).then(res => {
            if (res.personType ==0) {
              //跳转页面
              this.$router.push("/console");
            }else {
              this.$router.push("/developers");
            }
            // this.$message.success("登录成功！");
           
          })
          
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped lang="scss">
.login-main {
  width: 100%;
  height: 100%;
}
.reset-btn-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  width: 100%;
  top: 200px;
  height: 40px;

  span {
    cursor: pointer;
    color: rgba(58, 98, 215, 100);
    font-size: 14px;
    font-family: PingFangSC-regular;
  }
}
.login-box {
  width: 100%;
  height: 100%;
}

.submit-btn {
  width: 100%;
  background-color: rgba(58, 98, 215, 100);
  color: #fff;
}

.login {
  width: 740px;
  height: 580px;
  left: 310px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 100);
  color: rgba(58, 98, 215, 100);
  font-size: 14px;
  box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.15);
  font-family: Roboto;
  display: flex;
}

.login-left {
  width: 330px;
  height: 100%;
  border-radius: 0px;
  background-color: rgba(58, 98, 215, 100);
  color: rgba(58, 98, 215, 100);
  font-size: 14px;
  box-shadow: 0px 1px 6px 1px rgba(0, 0, 0, 0.2);

  display: flex;
  align-items: center;
}
.login-left img {
  width: 90%;
  height: 260px;
  display: block;
  margin: 0 auto;
}

.login-right {
  flex: 1;
  padding: 50px 20px;
  display: flex;
  flex-direction: column;

  .login-top {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;

    div {
      display: flex;
      align-items: center;
      color: rgba(58, 98, 215, 100);
      font-size: 20px;
      font-family: PingFangSC-regular;
      width: 160px;
      height: 36px;
      border-bottom: 2px solid rgba(58, 98, 215, 100);
    }

    span {
      cursor: pointer;
      color: rgba(41, 83, 201, 100);
      font-size: 14px;
      font-family: PingFangSC-regular;
    }
  }

  .login-content {
    margin-top: 80px;
    width: 100%;
    flex: 1;
    position: relative;
  }
}
</style>
